import React from 'react';
import './utils/speechChunking'; // Chrome ~15s speech cutoff fix (Sep 30 2026)
import ReactDOM from 'react-dom/client';
import './index.css';

// Import API config early to ensure interceptors are registered
import './services/api_config';

import App from './App.jsx';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
